import OktaSignInWidget from '../../components/atoms/OktaSignInWidget';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useOktaAuth } from '@okta/okta-react';
import { useState } from 'react';
import { Typography } from '@mui/material';
import cs from 'classnames';
import { useStyles } from './style';
import { Fade, Grid, Box, Button } from '@mui/material';
import { getConfig } from '../../providers/ConfigProvider';
import { InlineBanner, TextField } from '@forgeglobal/forge-component-library';

const ResetPassword = (props: any) => {
  const { oktaAuth } = useOktaAuth();
  const nav = useNavigate();
  const { config } = props;
  const { classes } = useStyles();

  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | undefined>();
  const clearError = () => setError(undefined);

  const [email, setEmail] = useState('');

  const resetToken = searchParams.get('resetToken');

  const emailChanged = (e: any) => {
    setEmail(e.target.value);
  };

  const reset = async () => {
    const put = { Email: email };
    try {
      await axios.put(`${getConfig().API_BASE_URL}/Users/ResetPassword`, put);
      clearError();
      nav('/resetcomplete', { replace: true });
    } catch (error: any) {
      const message =
        error?.response?.data || 'An error occurred. Please contact support.';
      setError(message);
    }
  };

  return resetToken ? (
    <OktaSignInWidget
      config={config}
      onSuccess={(tokens: any) => oktaAuth.handleLoginRedirect(tokens)}
    />
  ) : (
    <div>
      {error && (
        <Fade in={true} timeout={750}>
          <div>
            <InlineBanner
              severity="error"
              text={error}
              action={
                <Button
                  sx={{ padding: 0 }}
                  size="small"
                  variant="text"
                  onClick={clearError}
                  data-test-id="password-success-button">
                  DISMISS
                </Button>
              }
            />
          </div>
        </Fade>
      )}
      <Grid
        container
        justifyContent="center"
        spacing={4}
        className={cs(classes.messageBody, classes.dialogBody)}>
        <Grid item className={classes.dialogBody}>
          <Typography
            className={classes.center}
            variant="h5"
            data-test-id="sub-title">
            Reset Password
          </Typography>
          <Typography className={classes.center} data-test-id="sub-title2">
            Please provide your email address below, and we will send you a link
            to reset your password.
          </Typography>
        </Grid>
        <Grid item className={classes.center}>
          <TextField
            sx={{ width: '100%', maxWidth: '460px' }}
            label="Email address"
            data-test-id="reset-password-input"
            name="email"
            onChange={(e: any) => {
              emailChanged(e);
            }}
          />
        </Grid>
        <Grid item className={classes.center}>
          <Box>
            <Button
              className={classes.button}
              data-test-id="submit-reset-password"
              size="medium"
              color="primary"
              type="submit"
              onClick={reset}>
              Reset Password
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default ResetPassword;
